// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"209":"2385f7f1","441":"c93ed64f","453":"64aababc"}[chunkId] + ".chunk.js";
};